<app-top-nav-registration [llttfPage]="true"></app-top-nav-registration>
<div class="h-30"></div>
<div class="container">
    <div class="content" role="main">
        <div class="facility-heading">{{headerMessage}}</div>
        <div class="designatedFacilityForm">
        <form [hidden]="hideEmailForm">
                <div class="form-fields">
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>Email</mat-label>
                      <input matInput class="form-control-textbox" [(ngModel)]="llttfparticipantemailmodel.email" name="email" />
                    </mat-form-field>
                    </div>
                  <div class="mb-10"></div>

                  <div class="form-buttons">
                    <input type="submit" class="submit-form-button" (click)="onSubmit()" value="Submit"/>

                  </div>
            </form>

            <span [hidden]="!hideEmailForm"><strong>Thank you! </strong>A registration link has been sent to your email.Please check your inbox and click on the link to continue the registration process.</span>
        </div>
    </div>
</div>
<app-footer></app-footer>
